import {isNil, isNotNil} from 'ramda';

import {FeatureShareItemType} from '../../../../../types/MarketType';

export function isInShareRange(
  sharePct: number | null,
  minShare: number | undefined,
  maxShare: number | undefined
): boolean {
  if (isNil(sharePct)) {
    return false;
  }
  if (isNotNil(minShare) && isNotNil(maxShare)) {
    return sharePct >= minShare && sharePct < maxShare;
  }
  if (isNotNil(maxShare)) {
    return sharePct < maxShare;
  }
  if (isNotNil(minShare)) {
    return sharePct >= minShare;
  }
  return true;
}

export function filterByShareRange(
  items: FeatureShareItemType[] | undefined,
  minShare: number | undefined,
  maxShare: number | undefined
): FeatureShareItemType[] {
  return (items ?? []).filter((item) => isInShareRange(item.share_pct, minShare, maxShare));
}
